import { render, staticRenderFns } from "./GradingReportSummary.vue?vue&type=template&id=01e28858&scoped=true&"
import script from "./GradingReportSummary.vue?vue&type=script&lang=js&"
export * from "./GradingReportSummary.vue?vue&type=script&lang=js&"
import style0 from "./GradingReportSummary.vue?vue&type=style&index=0&id=01e28858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e28858",
  null
  
)

export default component.exports